"use client"

// src/ui-provider.tsx
import {
  ColorModeProvider,
  EnvironmentProvider,
  GlobalStyle,
  I18nProvider,
  ResetStyle,
  ThemeProvider
} from "@yamada-ui/core";
import { LoadingProvider } from "@yamada-ui/loading";
import { MotionConfig } from "@yamada-ui/motion";
import { NoticeProvider } from "@yamada-ui/notice";
import { defaultConfig, defaultTheme } from "@yamada-ui/theme";
import { jsx, jsxs } from "react/jsx-runtime";
var UIProvider = ({
  children,
  colorMode,
  colorModeManager,
  colorModeStorageKey,
  config = defaultConfig,
  disableEnvironment,
  disableGlobalStyle,
  disableResetStyle,
  environment,
  theme = defaultTheme,
  themeSchemeManager,
  themeSchemeStorageKey
}) => {
  var _a;
  return /* @__PURE__ */ jsx(
    EnvironmentProvider,
    {
      disabled: disableEnvironment,
      environment,
      children: /* @__PURE__ */ jsx(I18nProvider, { direction: config.direction, locale: config.locale, children: /* @__PURE__ */ jsx(
        ThemeProvider,
        {
          config,
          storageKey: themeSchemeStorageKey,
          theme,
          themeSchemeManager,
          children: /* @__PURE__ */ jsx(
            ColorModeProvider,
            {
              colorMode,
              colorModeManager,
              config,
              storageKey: colorModeStorageKey,
              children: /* @__PURE__ */ jsx(MotionConfig, { ...(_a = config.motion) == null ? void 0 : _a.config, children: /* @__PURE__ */ jsxs(LoadingProvider, { ...config.loading, children: [
                !disableResetStyle ? /* @__PURE__ */ jsx(ResetStyle, {}) : null,
                !disableGlobalStyle ? /* @__PURE__ */ jsx(GlobalStyle, {}) : null,
                children,
                /* @__PURE__ */ jsx(NoticeProvider, { ...config.notice })
              ] }) })
            }
          )
        }
      ) })
    }
  );
};

export {
  UIProvider
};
//# sourceMappingURL=chunk-DPZLMFIO.mjs.map